import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { clsx } from 'clsx';

export interface LinkProps {
  href: string;
  children: React.ReactNode;
  external?: boolean;
  className?: string;
}

export function Link({ href, children, external = false, className }: LinkProps) {
  const baseClasses =
    'text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 transition-colors duration-200';

  if (external || href.startsWith('http')) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={clsx(baseClasses, className)}
      >
        {children}
      </a>
    );
  }

  return (
    <RouterLink to={href} className={clsx(baseClasses, className)}>
      {children}
    </RouterLink>
  );
}
